import React, { Component } from "react";
import initWorkoutParticipant from "../../streaming/ParticipantNextWorkout";

class FooterActivity extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			activityArray: [],
			isOpenList: false
		}
	}
 
	componentDidMount(){
		if ( localStorage.getItem('userData') )   
			{
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
				if ( sessionData.scriptDetail && sessionData.scriptDetail.length > 0 ) 
					{ 
						if ( !sessionData.ondemandId ) 
							{
								for ( let i = 0; i < sessionData.scriptDetail.length; i++ )
									{
										if ( sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause' || sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												sessionData.scriptDetail.splice(i, 1);
												i--;
											}
									}
							}
						this.setState({activityArray: sessionData.scriptDetail});
						initWorkoutParticipant();
					}
			}	
	}
	
	openActivity=()=>{
		if ( !this.props.activityListOpen )
			{
				this.props.updateStateFromChild({rightMenuOpen: true, activityListOpen: true, participantStatsOpen: false, chatOpen: false});
			}
		else
			{
				this.props.updateStateFromChild({rightMenuOpen: false, activityListOpen: false, participantStatsOpen: false, chatOpen: false});
			}
	}
	
	openCloseList=()=>{
		var isOpenVar = this.state.isOpenList;
		isOpenVar = !isOpenVar;
		this.setState({isOpenList: isOpenVar});
	}
	
	render() {
		return (
			<div>
				{ this.state.activityArray.length > 0 &&
					<div>
						<div className={"workout_menu " + (this.state.isOpenList ? 'opened_workout_list' : '')} onClick={this.openCloseList}><span id="nextActName" > Up Next</span> <span id="currentIndex"></span>/{this.state.activityArray.length}
							<div className={"open_workout_arrow " + (this.state.isOpenList ? 'opened_workout_arrow' : '')}></div>
						</div>
						<div className={"bottom_activity_container " + (!this.state.isOpenList ? 'd-none' : '')}>
							<div className="next_name" id="workoutName"></div>
							<div className="next_type" id="workoutType"></div>
							<div id="viewAllAct" className="view_all_act" onClick={this.openActivity}>View all activities</div>
						</div>
					</div>
				}
			</div>
	)}
}
export default FooterActivity;
